<div class="uls declared-compliant-page ul-card">
  <header class="document-header">
    @if (!isSharedView() && shareUrl(); as shareUrl) {
      <div class="share-button-container">
        <button
          type="button"
          class="share-button"
          (click)="toggleSharePanel()"
          [attr.aria-expanded]="isSharePanelOpen()"
          aria-haspopup="dialog"
        >
          {{ 'declaredCompliant.share.button' | translate }}
        </button>
        @if (isSharePanelOpen()) {
          <section
            class="share-panel"
            role="dialog"
            [attr.aria-label]="'declaredCompliant.share.dialogAriaLabel' | translate"
          >
            <p class="share-panel__title">{{ 'declaredCompliant.share.title' | translate }}</p>
            <label class="share-panel__label" for="share-link">
              {{ 'declaredCompliant.share.linkLabel' | translate }}
            </label>
            <input
              id="share-link"
              class="share-panel__input"
              type="text"
              [value]="shareUrl"
              readonly
            />
            <div class="share-panel__actions">
              <button
                type="button"
                class="share-button share-button--primary"
                (click)="copyShareUrl(shareUrl)"
              >
                {{ 'declaredCompliant.share.copyLink' | translate }}
              </button>
              <button
                type="button"
                class="share-button share-button--link"
                (click)="openShareUrl(shareUrl)"
              >
                {{ 'declaredCompliant.share.openLink' | translate }}
              </button>
              <button
                type="button"
                class="share-button share-button--link"
                (click)="closeSharePanel()"
              >
                {{ 'general.close' | translate }}
              </button>
            </div>
            @if (shareMessage()) {
              <p class="share-panel__feedback share-panel__feedback--success" role="status">
                {{ shareMessage() }}
              </p>
            }
            @if (errorMessage()) {
              <p class="share-panel__feedback share-panel__feedback--error" role="alert">
                {{ errorMessage() }}
              </p>
            }
          </section>
        }
      </div>
    }
    <p class="eyebrow">{{ 'declaredCompliant.eyebrow' | translate }}</p>
    <h1 class="page-title">{{ 'declaredCompliant.title' | translate }}</h1>
    <p class="intro-text">{{ 'declaredCompliant.intro' | translate }}</p>
  </header>
  @if (isLoading()) {
    <p>{{ 'declaredCompliant.loadingDocument' | translate }}</p>
  } @else if (assessmentResult(); as assessmentResult) {
    <section class="info-panel" aria-labelledby="component-information-title">
      <h2 id="component-information-title" class="section-title">
        {{ 'declaredCompliant.productInformationTitle' | translate }}
      </h2>
      <dl class="info-grid">
        <dt>{{ 'declaredCompliant.manufacturerNameLabel' | translate }}</dt>
        <dd>{{ assessmentResult.manufacturerName || ('general.no_data' | translate) }}</dd>

        <dt>{{ 'model.product.properties.name' | translate }}</dt>
        <dd>{{ assessmentResult.productName || ('general.no_data' | translate) }}</dd>

        <dt>{{ 'model.productRevision.singular' | translate }}</dt>
        <dd>{{ assessmentResult.productRevision || ('general.no_data' | translate) }}</dd>

        <dt>{{ 'model.product.properties.description' | translate }}</dt>
        <dd>{{ assessmentResult.productDescription || ('general.no_data' | translate) }}</dd>
      </dl>
    </section>

    <section class="info-panel" aria-labelledby="analysis-title">
      <h2 id="analysis-title" class="section-title">
        {{ 'declaredCompliant.requirementAssessmentStatusTitle' | translate }}
      </h2>
      <dl class="info-grid compact">
        <dt>{{ 'declaredCompliant.counts.pass' | translate }}</dt>
        <dd>{{ assessmentResult.passedCount ?? 0 }}</dd>

        <dt>{{ 'declaredCompliant.counts.failed' | translate }}</dt>
        <dd>{{ assessmentResult.failedCount ?? 0 }}</dd>

        <dt>{{ 'declaredCompliant.counts.notApplicable' | translate }}</dt>
        <dd>{{ assessmentResult.notApplicableCount ?? 0 }}</dd>

        <dt>{{ 'declaredCompliant.counts.notAssessed' | translate }}</dt>
        <dd>{{ assessmentResult.notAssessedCount ?? 0 }}</dd>
      </dl>
    </section>

    <section class="info-panel" aria-labelledby="declaration-title">
      <h2 id="declaration-title" class="section-title">
        {{ 'declaredCompliant.declarationStatementTitle' | translate }}
      </h2>
      <p>{{ 'declaredCompliant.declarationStatementText' | translate }}</p>
    </section>
    <section
      class="status-banner"
      [attr.aria-label]="'declaredCompliant.declarationStatusAriaLabel' | translate"
    >
      <div>
        <p class="status-banner__label">
          {{ 'declaredCompliant.declarationStatusLabel' | translate }}
        </p>
        <p class="status-banner__value">{{ assessmentResult.declarationStatus }}</p>
      </div>
      <div>
        <p class="status-banner__label">
          {{ 'declaredCompliant.declarationDateLabel' | translate }}
        </p>
        <p class="status-banner__value">
          {{
            assessmentResult.declarationDateUtc
              ? (assessmentResult.declarationDateUtc | date: 'medium')
              : ('declaredCompliant.notDeclaredYet' | translate)
          }}
        </p>
      </div>
      <div class="standards">
        <p class="status-banner__label">
          {{ 'declaredCompliant.assessedStandardsLabel' | translate }}
        </p>
        <!-- due to style white-space: pre-line -->
        <!-- prettier-ignore -->
        <p class="status-banner__value">{{ assessmentResult.standardName ?? ('declaredCompliant.unknown' | translate) }}</p>
      </div>
      <div>
        <p class="status-banner__label">
          {{ 'declaredCompliant.declarationSubmittedByLabel' | translate }}
        </p>
        <p class="status-banner__value">
          {{ assessmentResult.createdByFullname || ('general.no_data' | translate) }}
        </p>
      </div>
      <div>
        <p class="status-banner__label">&nbsp;</p>
        <p class="status-banner__value">
          {{ assessmentResult.createdByEmail || ('general.no_data' | translate) }}
        </p>
      </div>
    </section>
  } @else {
    <p>{{ 'declaredCompliant.unableToLoadDetails' | translate }}</p>
  }

  @if (errorMessage() && !isSharePanelOpen()) {
    <p class="feedback error" role="alert">{{ errorMessage() }}</p>
  }
</div>
